<template name="checkUser">
  <div class="ko-list">
    <div class="ko-list-header">
      <div class="inner">
        <div class="row">
          <div class="col-1">
            <img src="../assets/images/invalid-name.png" alt="back" @click="changeKO(true)" class="arrow-back">
          </div>
          <div class="col-10 select-icon">
            <span>{{$t('SelectApprover')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="ko-list-content">
      <div class="no-data" v-show="!checkUserList.length">
        {{$t('contactAdministrator')}}
      </div>
      <div class="inner">
        <div class="row" v-for="(item, idx) in this.checkUserList" :key="idx">
          <div class="col-10">
            <img class="head-portrait" :id="item.userId" :src="item.avatar">
            <span>{{ item.userName }}({{ item.deptName }})</span>
          </div>
          <div class="col-2">
            <span class="check-item" :class="item.checkboxed ? 'checkboxed' : '' "
            @click="toggleCheck(item.userId)"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="ko-list-footer" v-show="isFooterShown && checkUserList.length">
      <div class="inner">
        <div class="row">
          <div>
            <button class="btn btn-gradient" @click="changeKO(false)">{{$t('submit')}}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="ko-list-confirm" v-show="isConfirmShown">
      <div class="confirm-wrapper">
        <div class="confirm-header">
          {{$t('exitReviewer')}}
        </div>
        <div class="confirm-btn" @click="isConfirmShown = false">
          {{$t('confirm')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { getDeliveryTrackingAdminList } from '@/utils/api';
import { checkNested } from '@/utils/utils';

export default {
  name: 'checkUser',
  data() {
    return {
      pickedKOList: [],
      isConfirmShown: false,
      isFooterShown: true,
      checkUserList: [],
    };
  },
  props: {
    invitationId: String
  },
  created() {
    const invitationId = this.invitationId;
    // console.log(invitationId)
    if (invitationId) {
      getDeliveryTrackingAdminList(invitationId).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          // console.log(res.data.content.model);
          if (res.data.content.model) {
            this.checkUserList = res.data.content.model;
            this.checkUserList.forEach(x => x.checkboxed = false);
            // console.log( this.checkUserList);
          }
        }
      });
    }
  },
  methods: {
    changeKO(isBack) {
      if (isBack) {
        this.$emit('closeCheckUser', false);
      } else if (this.pickedKOList.length && !isBack){
        this.$emit('CheckStatus', this.pickedKOList);
        this.checkUserList.forEach(x => x.checkboxed = false);
        this.pickedKOList = [];
        this.$emit('closeCheckUser', false);
      } else {
         this.isConfirmShown = true;
      }
    },
    toggleCheck(id) {
      const { checkUserList } = this;
      const user = checkUserList.find(x => x.userId === id);
      user.checkboxed = !user.checkboxed;
      for (var i=0; i<checkUserList.length; i++){
          var obj = new Object();
          obj.userId = checkUserList[i].userId;
          obj.deptName = checkUserList[i].deptName;
          obj.userName = checkUserList[i].userName;
          obj.avatar = checkUserList[i].avatar;
          obj.checkboxed = checkUserList[i].checkboxed;
          this.$set(this.checkUserList,i,obj)
      }
      this.checkUserList = checkUserList;
      const duplicatedRemovedList = this.checkUserList.filter(x => x.checkboxed && this.pickedKOList.findIndex(y => y.userId === x.userId) === -1);
      this.pickedKOList = user.checkboxed ? [...this.pickedKOList, ...duplicatedRemovedList]
        : this.pickedKOList.filter(x => x.userId !== id);
      // console.log(this.pickedKOList);
      // console.log(this.checkUserList);
      
    },
  },
};
</script>

<style scoped lang="scss">
.btn-gradient {
  color: #fff;
  background-image: linear-gradient(73deg, #f36443, #e42029);
  &:hover {
    color: #fff;
  }
}
.ko-list {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: #fff;
  top: 0;
  left: 0;
}
.ko-list-content {
  position: absolute;
  left: 0;
  top: 56px;
  bottom: 56px;
  overflow: auto;
  width: 100%;
  .no-data {
    font-size: 14px;
    text-align: center;
    color: #929292;
    font-weight: bold;
    padding-top: 40px;
  }
  & > div {
    padding: 0;
    width: 90%;
    margin: auto;
    .row {
      margin: 0;
      padding-top: 16px;
      padding-bottom: 12px;
      align-items: center;
      border-bottom: 1px solid #f0f1f2;
      div {
        padding: 0;
        // font-family: HiraginoSansGB-W3;
        font-size: 13px;
        color: #4a4a4a;
        img.head-portrait {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 16px;
        }
        .check-item {
          display: inline-block;
          width: 20px;
          height: 20px;
          background: url('../assets/images/copy-14.png');
          background-size: contain;
          border-radius: 50%;
          &.checkboxed {
            background-image: url('../assets/images/xuanzhong-copy-6.png');
          }
        }
      }
      & > div:nth-of-type(2) {
        text-align: right;
        padding-right: 10px;
      }
    }
  }
}
.ko-list-picked {
  @extend .ko-list-content;
  background: rgba(0,0,0,.4);
  .ko-list-picked-header {
    font-size: 14px;
    text-align: center;
    color: #4a4a4a;
    font-weight: bold;
    line-height: 38px;
    border-bottom: 1px solid #f0f1f2;
  }
  .inner {
    background: #fff;
    position: absolute;
    bottom: 0;
    width: 100%;
    & > div {
      max-height: 266px;
      overflow: auto;
      .row {
        width: 90%;
        margin: auto;
        padding: 6px 0;
        .check-item {
          background-image: url('../assets/images/2-copy-12@2x.png');
        }
      }
    }
  }
}
.ko-list-confirm {
  height: calc(100vh - 56px);
  background: rgba(0,0,0,.4);
  z-index: 100;
  position: absolute;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .confirm-wrapper {
    background: #fcfcfc;
    width: 72%;
    border-radius: 12px;
    font-size: 17px;
    text-align: center;
    .confirm-header {
      padding: 34.5px 0 20px;
      border-bottom: 1px solid #f0f1f2;
    }
    .confirm-btn {
      padding: 12px 0;
      color: #e42029;
    }
  }
}
.ko-list-header {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  box-shadow: 0 0 15px rgba(100,100,100,.2);
  .col-12 {
    position: relative;
  }
  .select-icon {
    font-size: 14px;
    font-weight: 600;
    color: #4a4a4a;
  }
  i {
    position: absolute;
    top: 0;
    left: 25px;
    line-height: 36px;
    color: #999;
    font-size: 18px;
  }
  .inner {
    width: 90%;
    padding: 10px 0;
    margin: 0 auto;
  }
  .form-control {
    height: 36px;
    border-radius: 18px;
    border: 0;
    font-size: 14px;
    padding: 11px 20px 11px 36px;
    background: #f1f1f1;
  }
  .clear-input {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 10px;
    top: 8px;
  }
  .col-1 {
    display: flex;
    align-items: center;
    img {
      width: 18px;
    }
  }
  .col-9 {
    position: relative;
    padding-right: 0;
  }
  .search-btn {
    color: #4a4a4a;
    font-size: 14px;
    padding: 0;
    .btn {
      border: 0;
      font-size: 14px;
      color: #929292;
      &.searchable {
        color: #e42029;
      }
    }
  }
  &.show-mask:after {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10;
  }
}
.ko-list-footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  line-height: 36px;
  box-shadow: 0 0 15px rgba(100,100,100,.2);
  .inner {
    width: 90%;
    padding: 10px 0;
    margin: 0 auto;
    div {
      width: 100%;
      margin: 0;
    }
  }
  .btn {
    font-size: 15px;
    display: block;
    width: 100%;
  }
  .col-5 {
    font-size: 14px;
    color: #929292;
    strong {
      font-size: 16px;
      color: #e42029;
      padding: 0 5px;
    }
  }
  .col-3 {
    font-size: 12px;
    color: #4a4a4a;
    text-align: right;
    padding-right: 0;
    i {
      font-size: 12px;
      transform: scale(0.6,0.6);
      display: inline-block;
    }
  }
}
</style>
